import { useState } from "react";

interface UsePaginationProps {
  totalPages: number;
  initialPage?: number;
}

interface UsePaginationReturn {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  handlePageChange: (direction: number) => void;
}

export const usePagination = ({
  totalPages,
  initialPage = 1,
}: UsePaginationProps): UsePaginationReturn => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  // Hook function: sends parameter and returns the function
  const handlePageChange = (direction: number) => {
    if (currentPage === 1 && direction === -1) {
      return;
    }
    if (currentPage === totalPages && direction === 1) {
      return;
    }

    const newPage = currentPage + direction;
    setCurrentPage(newPage);
  };

  return {
    currentPage,
    setCurrentPage,
    handlePageChange,
  };
};
